// Over/Under Billings for the cost status Financial Summary:
// cumulative invoiced - revised contract value x % complete.
// Returns null where there is nothing honest to show, so the table renders "--".

const percentComplete = (summary) =>
	Math.abs(summary?.total_estimated_costs) > 1
		? Number((summary.jtd_costs / summary.total_estimated_costs).toFixed(2))
		: 0;

const overUnderBillings = (summary, invoice) =>
	invoice.cumulative_invoiced - percentComplete(summary) * (summary?.revised_contract_value || 0);

export const currentOverUnderBillings = (currentSummary, invoices) => {
	const latest = invoices?.[invoices.length - 1];
	return latest ? overUnderBillings(currentSummary, latest) : null;
};

// Without a comparison snapshot there is no prior month. Falling back to an
// invoice row anyway compared against a partial running total mid pay app.
export const priorOverUnderBillings = (priorSummary, invoices) => {
	if (!priorSummary) return null;
	const previous = invoices?.length > 1 ? invoices[invoices.length - 2] : null;
	return previous ? overUnderBillings(priorSummary, previous) : null;
};
